import { NumberField } from "@fluentui/web-components";
import { css, html, LitElement } from "lit";
import { customElement, property, query } from "lit/decorators.js";
import { ifDefined } from "lit/directives/if-defined.js";

// create due to a bug in decimal step validation
// only needed properties have been added, 
// if you bring in validation you will need to fix the step bug (0.1 value is never valid, even with step=0.1 )
@customElement("ctx-fluent-number-field-patched")
export class CtxFluentNumberFieldPatched extends LitElement {
  static styles = [
    css`
      :host {
        display: contents;
        --input-placeholder-rest: #b5b5b5;
        --input-placeholder-hover: #d9d9d9;
      }
    `
  ];

  @property() value?: any
  @property({type:Number}) step?: number
  @property({type:Number}) size?: number
  @property({type:Number}) min?: number
  @property({type:Number}) max?: number
  @property({type:Number}) placeholder?: number
  @property({type:Boolean}) disabled?: boolean

  @query('fluent-number-field') numberField!: NumberField

  get valueAsNumber() {
    
    return this.numberField.valueAsNumber;
  }

  render() {
    return html`
      <fluent-number-field
        ?disabled=${this.disabled}
        exportparts="control"
        .placeholder=${this.placeholder}
        .value=${this.value}
        .step=${this.step}
        .size=${this.size}
        min=${ifDefined(this.min)}
        max=${ifDefined(this.max)}
      ></fluent-number-field>
    `;
  }
}